import React from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import '../contents/css/radio-input.css';

export default class RadioInput extends React.Component {
    render() {
        return (
            <CheckBoxStyled className={'radio-input' + (this.props.className ? (' ' + this.props.className) : '')}
            
            >
                <Form.Label
                    style={{
                        display: 'flex',
                        textAlign: 'left',
                        cursor: 'pointer',
                        marginBottom: 0,
                    }}
                >
                    <Form.Check
                        type='radio' 
                        defaultChecked={this.props.defaultValue}
                        onChange={(e) => {
                            if (this.props.onChange) {
                                this.props.onChange(e.target.checked ? true : false);
                            }
                        }}
                        style={this.props.style}
                        name={this.props.name}
                        id={this.props.id}
                        key={this.props.key} 
                        ref={this.props.ref}
                    />
                    <span>{this.props.label}</span>
                </Form.Label>
            </CheckBoxStyled>
        );
    }
}

const CheckBoxStyled = styled.div`
    .form-label {
        display: flex;
    }

    .form-check {
        display: flex;
        text-align: center;
        padding-left: 3px;
        padding-right: 5px;
    }

    .form-check-input {
        margin: auto;
        cursor: pointer;
        height: 16px;
        width: 16px;
    }
`;

